import React, { useState, useEffect } from "react"
import styled, { css } from "styled-components"
import Form from "../../Form"
import { sendAnalyticsEvent } from "../../analytics"
import { keyBy, flattenDeep, get, flatten, pick } from "lodash"

const CustomLayout = styled.div`
  width: 100%;
  max-width: 100%;
  height: auto;
  position: relative;
  padding-top: 15px;
  ${props =>
    props.visible &&
    css`
      /* min-height: 300px; */
    `}
`

const LoadingOverlay = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background: white;
  transition: all 0.3s ease-out;
  /* min-height: 300px; */
  pointer-events: none;
  z-index: 1000;
  opacity: ${props => (props.visible ? 1 : 0)};
`

export default props => {
  let questionMap = keyBy(
    flattenDeep(
      get(props, "form.questions", []).map(questionGroup => {
        const questions = get(questionGroup, "questions", []).map(question => ({
          ...question.question,
          type: question.__typename,
        }))
        if (questionGroup.__typename == "SanityQuestionGroup") {
          return [
            {
              identifier: questionGroup.identifier,
              questions: questions.map(q => q.identifier),
            },
            ...questions,
          ]
        }
        return questions
      })
    ),
    "identifier"
  )
  const questionProcessed = (identifier, value, formState) => {
    if (identifier) {
      sendAnalyticsEvent(props.form.name, "QuestionProcessed", identifier)

      const questionType = get(questionMap, [identifier, "type"])
      const question = get(questionMap, [identifier])
      let questionAnswer = ""

      if (question.questions) {
        sendAnalyticsEvent(props.form.name, identifier, value)
        sendAnalyticsEvent("questionSubmitted", null, null, {
          claimcheckType: props.form.name,
          claimcheckQuestionID: identifier,
          claimcheckQuestion: "",
          claimcheckAnswer: "",
        })

        // question.questions.map(identifier => {
        //   const questionType = get(questionMap, [identifier, "type"])

        //   if (
        //     questionType.indexOf("Email") > -1 ||
        //     questionType.indexOf("Text") > -1
        //   ) {
        //     questionAnswer = "*"
        //   } else {
        //     questionAnswer = get(formState, identifier, "") + ""
        //   }
        //   sendAnalyticsEvent(props.form.name, identifier, questionAnswer)

        //   sendAnalyticsEvent("questionSubmitted", null, null, {
        //     claimcheckType: props.form.name,
        //     claimcheckQuestionID: identifier,
        //     claimcheckQuestion: get(questionMap, [identifier, "text"]),
        //     claimcheckAnswer: questionAnswer,
        //   })
        // })
      } else {
        if (
          questionType.indexOf("Email") > -1 ||
          questionType.indexOf("Text") > -1
        ) {
          questionAnswer = "*"
        } else {
          questionAnswer = value + ""
        }
        sendAnalyticsEvent(props.form.name, identifier, questionAnswer)

        sendAnalyticsEvent("questionSubmitted", null, null, {
          claimcheckType: props.form.name,
          claimcheckQuestionID: identifier,
          claimcheckQuestion: get(questionMap, [identifier, "text"]),
          claimcheckAnswer: questionAnswer,
        })
      }

      console.log("Processed", identifier, props.submissionIdentifier)

      if (
        props.submissionIdentifier &&
        props.submissionIdentifier == identifier
      ) {
        if (props.formIdentifierOnly) {
          const formIdentifiers = flatten(
            get(props, "form.questions", []).map(question =>
              get(question, "questions", []).map(question =>
                get(question, "question.identifier", "")
              )
            )
          )
          props.finishedForm(pick(formState, formIdentifiers))
        } else {
          props.finishedForm(formState)
        }
      }
    }
  }

  const questionViewed = identifier => {
    console.log("question viewed", identifier)
    if (identifier) {
      sendAnalyticsEvent(props.form.name, "QuestionViewed", identifier)
      sendAnalyticsEvent("questionViewed", null, null, {
        claimcheckType: props.form.name,
        claimcheckQuestionID: identifier,
        claimcheckQuestion: get(questionMap, [identifier, "text"]),
      })
    }
  }

  const [visible, setVisibility] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setVisibility(true)
    }, 100)
  }, [setVisibility])
  return (
    <CustomLayout visible={visible}>
      <LoadingOverlay visible={!visible}></LoadingOverlay>
      <Form
        {...props.form}
        visible={visible}
        isNavigationFixed={props.isNavigationFixed}
        showProgress={props.showProgress}
        onQuestionProcessed={questionProcessed}
        onQuestionView={questionViewed}
        initialState={props.state}
      />
    </CustomLayout>
  )
}
